import { keyframes } from 'styled-components';

export const down = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-150px);
  }
  75% {
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
`;

export const up = keyframes`
  0% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: translateY(-150px);
  }
`;

export const left = keyframes`
  from {
    opacity: 0;
    transform: translateX(150px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const right = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(150px);
  }
`;

export const fadeIn = keyframes`
  to {
    background: rgba(0, 0, 0, 0.2);
  }
`;

export const fadeOut = keyframes`
  to {
    background: rgba(0, 0, 0, 0);
  }
`;

export const openUp = keyframes`
  0% {
    bottom: -330px;
  }
  100% {
    bottom: 0px;
  }
`;

export const closeDown = keyframes`
  0% {
    bottom: 0px;
  }
  100% {
    bottom: -500px;
  }
`;
